import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/provider/AuthProvider';
import './LogOutButton.css';
import { clsx } from 'clsx';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import Button from 'src/components/Button/Button';
import useBroadcast from 'src/hooks/useBroadcast';
import { BROADCAST_CHANNELS, BROADCAST_MESSAGES } from 'src/constants/broadcast';
import { PATH_AUTH_SPA } from 'src/constants/spa-routes';
import { useAppSelector } from 'src/store';
import { useLogoutMutation } from 'src/services/authSsoService';
import { useLoader } from 'src/provider/LoaderProvider';
import { SidebarLogoutIcon } from 'src/assets/icons/sidebar/sidebarLogoutIcon';

const LogOutButton = ({ className }) => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const loader = useLoader();

  const { storageMenuOpen } = useAppSelector((s) => s.menuSlices);

  const { channelInstance } = useBroadcast({
    channelName: BROADCAST_CHANNELS.AUTH,
  });

  const [logOut, { isLoading: isLoadingLogOut, isSuccess: isSuccessLogOut }] = useLogoutMutation();

  useEffect(() => {
    if (isLoadingLogOut) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingLogOut]);

  useEffect(() => {
    if (isSuccessLogOut) {
      setUser(null);
      localStorage.removeItem('user');
      navigate(PATH_AUTH_SPA.ROOT);
    }
  }, [isSuccessLogOut]);

  const logout = () => {
    const tokensStr = localStorage.getItem('user');
    const tokens: any = tokensStr && tokensStr !== 'undefined' && JSON.parse(tokensStr);

    logOut({ refresh_token: tokens?.refresh_token || tokens?.refresh });

    if (channelInstance) {
      channelInstance.postMessage(BROADCAST_MESSAGES.LOGOUT);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="logout-container flex items-center">
          <div className={clsx('logout-button w-full py-2', className)}>
            <p
              className={clsx(
                !storageMenuOpen && 'opacity-0',
                'transition-all absolute left-16 duration-300 text-white text-sm font-medium text-ellipsis overflow-hidden text-nowrap',
              )}
            >
              Log Out
            </p>
            <div className="p-2">
              <SidebarLogoutIcon />
            </div>
          </div>
        </div>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Log out</DialogTitle>
          <DialogDescription>Are you sure you want to log out?</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button className="transparent black !w-fit">Cancel</Button>
          </DialogClose>
          <DialogClose asChild autoFocus onClick={logout}>
            <Button className="transparent red !w-fit">Log Out</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LogOutButton;
